import './Statistics.sass';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Header, InlineHeader, Placeholder, ScrollView, Tabs, TabsItem } from '$uikit';
import { Loader, MetaTags } from '$shared/components';
import { useTranslator } from '$hooks';
import { StatisticsItem } from '$core/Statistics/StatisticsItem/StatisticsItem';
import { statisticsActions, statisticsSelector } from '$store/statistics';
import { CurrencyEnum } from '$store/models';

export const Statistics = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [currencyTab, setCurrencyTab] = useState<CurrencyEnum>(CurrencyEnum.EUR);
  const { items, isItemsLoading } = useSelector(statisticsSelector);
  const currentTabItems = items[currencyTab];

  useEffect(() => {
    dispatch(statisticsActions.loadStatisticsItems());
  }, []);

  function renderContent() {
    if (!isItemsLoading && !currentTabItems?.length) {
      return <Placeholder>{t('statistics_empty')}</Placeholder>;
    }

    if (isItemsLoading) {
      return <Loader isWrapped />;
    }

    return (
      <ScrollView className="Statistics">
        <Tabs
          selected={currencyTab}
          onChange={(tab) => setCurrencyTab(tab as CurrencyEnum)}
        >
          {Object.values(CurrencyEnum).map((currency) => (
            <TabsItem value={currency} key={currency}>
              {currency.toUpperCase()}
            </TabsItem>
          ))}
        </Tabs>
        <div className="Statistics__earnings">
          <InlineHeader>{t('statistics_earnings')}</InlineHeader>
          <div className="Statistics__earnings__content">
            <StatisticsItem date={0} currentCurrency={currencyTab} />
            {currentTabItems
              .filter((item) => item.total > 0)
              .map((item) => {
                const { date, total } = item;
                return (
                  <StatisticsItem
                    date={date}
                    key={date}
                    totalAmount={total}
                    currentCurrency={currencyTab}
                  />
                );
              })}
          </div>
        </div>
      </ScrollView>
    );
  }

  return (
    <>
      <MetaTags title={t('other_statistics')} />
      <Header showBackButton>{t('other_statistics')}</Header>
      {renderContent()}
    </>
  );
};
